export const clusterDetailTable = {
    returnListLink: 'クラスタ一覧に戻る',
    title: 'クラスタID',
    selected: '選択中',
    tabTitleOfIpc: 'IPC（国際特許分類）',
    tabTitleOfCompany: '特許出願保有企業',
    tabTitleOfPatentTable: '特許出願一覧',
    tabTitleOfPatentChart: '特許出願推移'
}
